import React from 'react';
import { useSelector } from 'react-redux';
import RedirectToGatewayPage from '../../RedirectToGatewayPage/RedirectToGatewayPage';
import { selectSessionInformation } from '../../../../../redux/slices/sessionSlice';

function ProtectedReferralsRoute({ children }) {
  const { userAssignmentList, referralsEnabled } = useSelector(selectSessionInformation);
  const userHasReferralAccess = userAssignmentList.length > 0 && referralsEnabled;
  if (!userHasReferralAccess) {
    return <RedirectToGatewayPage />;
  }
  return children;
}

export default ProtectedReferralsRoute;
